/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'high-way': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M230.4 237.568q10.24-30.72 19.456-48.64t19.968-26.624 24.064-11.264 32.768-3.584H445.44L326.656 892.928H169.984q-63.488 0-80.384-44.544t7.68-126.464q8.192-26.624 19.456-67.072t24.064-87.04 25.6-96.256 25.088-94.72 22.016-81.408 16.896-57.856zm351.232 35.84H506.88l6.144-124.928h61.44zm14.336 311.296H492.544l11.264-248.832h80.896zm2.048 62.464L609.28 896H478.208l11.264-248.832h108.544zm400.384 87.04q7.168 22.528 11.264 50.176t0 51.712-18.944 40.448-44.544 16.384H759.808L640 147.456h96.256q51.2 0 86.016 22.528t53.248 80.896q6.144 18.432 15.36 57.344l22.528 88.064q12.288 49.152 25.088 102.4T962.56 599.04l21.504 83.968q9.216 36.864 14.336 51.2z"/>'
  }
})
